<fin-disclaimer [disclaimer]="content()" />
